import React from 'react';
import { components, SingleValueProps } from 'react-select';

export const SingleValue = (
	props: SingleValueProps & { data: { isDefault?: boolean } },
	isFilterStyle: boolean,
	placeholder?: string,
	isWithAsterisk?: boolean,
) => {
	return (
		<components.SingleValue {...props}>
			{isFilterStyle && `${placeholder}: `}
			<span
				style={{
					color: (props as any)?.data?.hoverColor,
				}}
			>
				{props.children}
				{props.data?.isDefault && isWithAsterisk && ' *'}
			</span>
		</components.SingleValue>
	);
};
